export default "__VITE_ASSET__DHblQzDq__"